import Datepicker from '@vuepic/vue-datepicker';
import ja from 'date-fns/locale/ja';
import selectboxEditor from './_selectbox_editor';

// 期間の正規表現フォーマット
const REGEX = /(20\d\d\/[0-1]\d\/[0-3]\d) ([0-2]\d:[0-5]\d)/;

/**
 * 期間編集コンポーネント
 */
export default {
    template: '#editor_component_template',
    data () {
        return {
            ja: ja,
        };
    },
    props: {
        // v-modelの値
        modelValue: {
            type: String,
            default: '',
        },
        // 選択不可日
        props_disabled_dates: {
            type: Object,
            default: () => ({to: null, from: null}),
            require: false,
        },
    },
    computed: {
        // 編集中のv-modelの値
        editValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
        // 日付
        date: {
            get() {
                if (this.modelValue) {
                    const matches = this.modelValue.match(REGEX);
                    if (matches) {
                        return new Date(matches[1]);
                    }
                }
                return null;
            },
            set(value) {
                value = moment(value).format('YYYY/MM/DD');
                const matches = this.modelValue.match(REGEX);
                const time = (matches) ? matches[2] : '00:00';
                this.$emit('update:modelValue', value + ' ' + time);
            },
        },
        minDate: function () {
            if (!this.props_disabled_dates.to) return null;

            return this.props_disabled_dates.to.clone().startOf('day').toDate();
        },
        maxDate: function () {
            if (!this.props_disabled_dates.from) return null;

            return this.props_disabled_dates.from.clone().endOf('day').toDate();
        }
    },
    components: {
        // カレンダーコンポーネント
        Datepicker,
        // セレクトボックスでの期間指定コンポーネント
        'selectbox-editor': selectboxEditor,
    },
    emits: ['update:modelValue'],
    methods: {
        // 現在時刻にする
        now: function () {
            this.editValue = moment().format('YYYY/MM/DD HH:mm');
        },
        /**
         * 日付のフォーマット
         * @param {Date} date
         * @return {String}
         */
        format: function (date) {
            if (!date) return '';

            const preview_date = createMoment(date).format('YYYY/MM/DD');
            const preview_time = createMoment(this.modelValue)?.format('HH:mm') ?? '00:00';
            return `${preview_date} ${preview_time}`;
        }
    }
};
